/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AddTeamNoteRequest,
  AddTimeOffRequest,
  CreateTeamMemberRequest,
  CreateTeamMemberResult,
  DeleteTeamMemberRequest,
  DeleteTeamNoteRequest,
  EditTeamNoteRequest,
  EngagementLetterResponse,
  GrantPermissionRequest,
  RemoveTimeOffRequest,
  SetHourlyRateRequest,
  TeamMemberDetail,
  TeamMemberSummary,
  TerminateTeamMemberRequest,
  UpdateTeamMemberRequest,
} from "../models/index";
import {
  AddTeamNoteRequestFromJSON,
  AddTeamNoteRequestToJSON,
  AddTimeOffRequestFromJSON,
  AddTimeOffRequestToJSON,
  CreateTeamMemberRequestFromJSON,
  CreateTeamMemberRequestToJSON,
  CreateTeamMemberResultFromJSON,
  CreateTeamMemberResultToJSON,
  DeleteTeamMemberRequestFromJSON,
  DeleteTeamMemberRequestToJSON,
  DeleteTeamNoteRequestFromJSON,
  DeleteTeamNoteRequestToJSON,
  EditTeamNoteRequestFromJSON,
  EditTeamNoteRequestToJSON,
  EngagementLetterResponseFromJSON,
  EngagementLetterResponseToJSON,
  GrantPermissionRequestFromJSON,
  GrantPermissionRequestToJSON,
  RemoveTimeOffRequestFromJSON,
  RemoveTimeOffRequestToJSON,
  SetHourlyRateRequestFromJSON,
  SetHourlyRateRequestToJSON,
  TeamMemberDetailFromJSON,
  TeamMemberDetailToJSON,
  TeamMemberSummaryFromJSON,
  TeamMemberSummaryToJSON,
  TerminateTeamMemberRequestFromJSON,
  TerminateTeamMemberRequestToJSON,
  UpdateTeamMemberRequestFromJSON,
  UpdateTeamMemberRequestToJSON,
} from "../models/index";

export interface AddTeamNoteOperationRequest {
  addTeamNoteRequest: AddTeamNoteRequest;
}

export interface AddTeamTimeOffRequest {
  addTimeOffRequest: AddTimeOffRequest;
}

export interface CreateTeamMemberOperationRequest {
  createTeamMemberRequest: CreateTeamMemberRequest;
}

export interface DeleteTeamMemberOperationRequest {
  deleteTeamMemberRequest: DeleteTeamMemberRequest;
}

export interface DeleteTeamNoteOperationRequest {
  deleteTeamNoteRequest: DeleteTeamNoteRequest;
}

export interface EditTeamNoteOperationRequest {
  editTeamNoteRequest: EditTeamNoteRequest;
}

export interface EngagementLetterForMemberRequest {
  teamMemberId: string;
}

export interface GetTeamMemberRequest {
  teamMemberId: string;
}

export interface GrantTeamPermissionRequest {
  grantPermissionRequest: GrantPermissionRequest;
}

export interface ListTeamMembersRequest {
  includeTerminated?: boolean;
}

export interface RemoveTeamTimeOffRequest {
  removeTimeOffRequest: RemoveTimeOffRequest;
}

export interface RevokeTeamPermissionRequest {
  grantPermissionRequest: GrantPermissionRequest;
}

export interface SetTeamHourlyRateRequest {
  setHourlyRateRequest: SetHourlyRateRequest;
}

export interface TerminateTeamMemberOperationRequest {
  terminateTeamMemberRequest: TerminateTeamMemberRequest;
}

export interface UpdateTeamMemberOperationRequest {
  updateTeamMemberRequest: UpdateTeamMemberRequest;
}

/**
 *
 */
export class PeopleTeamApi extends runtime.BaseAPI {
  /**
   */
  async addTeamNoteRaw(
    requestParameters: AddTeamNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["addTeamNoteRequest"] == null) {
      throw new runtime.RequiredError(
        "addTeamNoteRequest",
        'Required parameter "addTeamNoteRequest" was null or undefined when calling addTeamNote().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/add-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AddTeamNoteRequestToJSON(requestParameters["addTeamNoteRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async addTeamNote(
    requestParameters: AddTeamNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.addTeamNoteRaw(requestParameters, initOverrides);
  }

  /**
   */
  async addTeamTimeOffRaw(
    requestParameters: AddTeamTimeOffRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["addTimeOffRequest"] == null) {
      throw new runtime.RequiredError(
        "addTimeOffRequest",
        'Required parameter "addTimeOffRequest" was null or undefined when calling addTeamTimeOff().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/add-time-off`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AddTimeOffRequestToJSON(requestParameters["addTimeOffRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async addTeamTimeOff(
    requestParameters: AddTeamTimeOffRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.addTeamTimeOffRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createTeamMemberRaw(
    requestParameters: CreateTeamMemberOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateTeamMemberResult>> {
    if (requestParameters["createTeamMemberRequest"] == null) {
      throw new runtime.RequiredError(
        "createTeamMemberRequest",
        'Required parameter "createTeamMemberRequest" was null or undefined when calling createTeamMember().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/create`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateTeamMemberRequestToJSON(
          requestParameters["createTeamMemberRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateTeamMemberResultFromJSON(jsonValue),
    );
  }

  /**
   */
  async createTeamMember(
    requestParameters: CreateTeamMemberOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateTeamMemberResult> {
    const response = await this.createTeamMemberRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Erases a team member record entirely --- for one created by mistake, which otherwise keeps its work email claimed forever. Leadership-only and irreversible: notes, permissions, time off, meetings and change history all cascade away. Blocked once payroll has paid them, since those lines are financial records; terminating is the right answer for a real departure.
   * Erases a team member record entirely --- for one created by mistake, which otherwise keeps its work email claimed forever.
   */
  async deleteTeamMemberRaw(
    requestParameters: DeleteTeamMemberOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["deleteTeamMemberRequest"] == null) {
      throw new runtime.RequiredError(
        "deleteTeamMemberRequest",
        'Required parameter "deleteTeamMemberRequest" was null or undefined when calling deleteTeamMember().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/delete`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DeleteTeamMemberRequestToJSON(
          requestParameters["deleteTeamMemberRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Erases a team member record entirely --- for one created by mistake, which otherwise keeps its work email claimed forever. Leadership-only and irreversible: notes, permissions, time off, meetings and change history all cascade away. Blocked once payroll has paid them, since those lines are financial records; terminating is the right answer for a real departure.
   * Erases a team member record entirely --- for one created by mistake, which otherwise keeps its work email claimed forever.
   */
  async deleteTeamMember(
    requestParameters: DeleteTeamMemberOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteTeamMemberRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteTeamNoteRaw(
    requestParameters: DeleteTeamNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["deleteTeamNoteRequest"] == null) {
      throw new runtime.RequiredError(
        "deleteTeamNoteRequest",
        'Required parameter "deleteTeamNoteRequest" was null or undefined when calling deleteTeamNote().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/delete-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DeleteTeamNoteRequestToJSON(
          requestParameters["deleteTeamNoteRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteTeamNote(
    requestParameters: DeleteTeamNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteTeamNoteRaw(requestParameters, initOverrides);
  }

  /**
   */
  async editTeamNoteRaw(
    requestParameters: EditTeamNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["editTeamNoteRequest"] == null) {
      throw new runtime.RequiredError(
        "editTeamNoteRequest",
        'Required parameter "editTeamNoteRequest" was null or undefined when calling editTeamNote().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/edit-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EditTeamNoteRequestToJSON(
          requestParameters["editTeamNoteRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async editTeamNote(
    requestParameters: EditTeamNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.editTeamNoteRaw(requestParameters, initOverrides);
  }

  /**
   * Generate the engagement verification letter for another team member (admin path). Gated on \\`people.payroll.view\\` because the letter states annual compensation --- you can\'t print a salary you aren\'t allowed to see. The self-service equivalent lives at \\`/apollo/people/me\\`.
   * Generate the engagement verification letter for another team member (admin path).
   */
  async engagementLetterForMemberRaw(
    requestParameters: EngagementLetterForMemberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EngagementLetterResponse>> {
    if (requestParameters["teamMemberId"] == null) {
      throw new runtime.RequiredError(
        "teamMemberId",
        'Required parameter "teamMemberId" was null or undefined when calling engagementLetterForMember().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["teamMemberId"] != null) {
      queryParameters["teamMemberId"] = requestParameters["teamMemberId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/team/engagement-letter`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EngagementLetterResponseFromJSON(jsonValue),
    );
  }

  /**
   * Generate the engagement verification letter for another team member (admin path). Gated on \\`people.payroll.view\\` because the letter states annual compensation --- you can\'t print a salary you aren\'t allowed to see. The self-service equivalent lives at \\`/apollo/people/me\\`.
   * Generate the engagement verification letter for another team member (admin path).
   */
  async engagementLetterForMember(
    requestParameters: EngagementLetterForMemberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EngagementLetterResponse> {
    const response = await this.engagementLetterForMemberRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getTeamMemberRaw(
    requestParameters: GetTeamMemberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TeamMemberDetail>> {
    if (requestParameters["teamMemberId"] == null) {
      throw new runtime.RequiredError(
        "teamMemberId",
        'Required parameter "teamMemberId" was null or undefined when calling getTeamMember().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["teamMemberId"] != null) {
      queryParameters["teamMemberId"] = requestParameters["teamMemberId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/team/get`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TeamMemberDetailFromJSON(jsonValue),
    );
  }

  /**
   */
  async getTeamMember(
    requestParameters: GetTeamMemberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TeamMemberDetail> {
    const response = await this.getTeamMemberRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async grantTeamPermissionRaw(
    requestParameters: GrantTeamPermissionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["grantPermissionRequest"] == null) {
      throw new runtime.RequiredError(
        "grantPermissionRequest",
        'Required parameter "grantPermissionRequest" was null or undefined when calling grantTeamPermission().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/grant-permission`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: GrantPermissionRequestToJSON(
          requestParameters["grantPermissionRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async grantTeamPermission(
    requestParameters: GrantTeamPermissionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.grantTeamPermissionRaw(requestParameters, initOverrides);
  }

  /**
   * Defaults to people currently on the team. The directory page opts into the full list so it can offer a terminated filter; callers that pick someone to act on (team assignment, for one) get the safe default.
   * Defaults to people currently on the team.
   */
  async listTeamMembersRaw(
    requestParameters: ListTeamMembersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<TeamMemberSummary>>> {
    const queryParameters: any = {};

    if (requestParameters["includeTerminated"] != null) {
      queryParameters["includeTerminated"] =
        requestParameters["includeTerminated"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/people/team/list`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TeamMemberSummaryFromJSON),
    );
  }

  /**
   * Defaults to people currently on the team. The directory page opts into the full list so it can offer a terminated filter; callers that pick someone to act on (team assignment, for one) get the safe default.
   * Defaults to people currently on the team.
   */
  async listTeamMembers(
    requestParameters: ListTeamMembersRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<TeamMemberSummary>> {
    const response = await this.listTeamMembersRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async removeTeamTimeOffRaw(
    requestParameters: RemoveTeamTimeOffRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["removeTimeOffRequest"] == null) {
      throw new runtime.RequiredError(
        "removeTimeOffRequest",
        'Required parameter "removeTimeOffRequest" was null or undefined when calling removeTeamTimeOff().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/remove-time-off`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: RemoveTimeOffRequestToJSON(
          requestParameters["removeTimeOffRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async removeTeamTimeOff(
    requestParameters: RemoveTeamTimeOffRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.removeTeamTimeOffRaw(requestParameters, initOverrides);
  }

  /**
   */
  async revokeTeamPermissionRaw(
    requestParameters: RevokeTeamPermissionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["grantPermissionRequest"] == null) {
      throw new runtime.RequiredError(
        "grantPermissionRequest",
        'Required parameter "grantPermissionRequest" was null or undefined when calling revokeTeamPermission().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/revoke-permission`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: GrantPermissionRequestToJSON(
          requestParameters["grantPermissionRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async revokeTeamPermission(
    requestParameters: RevokeTeamPermissionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.revokeTeamPermissionRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setTeamHourlyRateRaw(
    requestParameters: SetTeamHourlyRateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["setHourlyRateRequest"] == null) {
      throw new runtime.RequiredError(
        "setHourlyRateRequest",
        'Required parameter "setHourlyRateRequest" was null or undefined when calling setTeamHourlyRate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/set-hourly-rate`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SetHourlyRateRequestToJSON(
          requestParameters["setHourlyRateRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setTeamHourlyRate(
    requestParameters: SetTeamHourlyRateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setTeamHourlyRateRaw(requestParameters, initOverrides);
  }

  /**
   * Records someone\'s final working day. They stay in the directory until that day passes, so a notice period is visible to everyone rather than the person vanishing the moment it\'s known. Reversible: clearing the end date on the profile reinstates them.
   * Records someone\'s final working day.
   */
  async terminateTeamMemberRaw(
    requestParameters: TerminateTeamMemberOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["terminateTeamMemberRequest"] == null) {
      throw new runtime.RequiredError(
        "terminateTeamMemberRequest",
        'Required parameter "terminateTeamMemberRequest" was null or undefined when calling terminateTeamMember().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/terminate`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: TerminateTeamMemberRequestToJSON(
          requestParameters["terminateTeamMemberRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Records someone\'s final working day. They stay in the directory until that day passes, so a notice period is visible to everyone rather than the person vanishing the moment it\'s known. Reversible: clearing the end date on the profile reinstates them.
   * Records someone\'s final working day.
   */
  async terminateTeamMember(
    requestParameters: TerminateTeamMemberOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.terminateTeamMemberRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateTeamMemberRaw(
    requestParameters: UpdateTeamMemberOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["updateTeamMemberRequest"] == null) {
      throw new runtime.RequiredError(
        "updateTeamMemberRequest",
        'Required parameter "updateTeamMemberRequest" was null or undefined when calling updateTeamMember().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/people/team/update`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateTeamMemberRequestToJSON(
          requestParameters["updateTeamMemberRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateTeamMember(
    requestParameters: UpdateTeamMemberOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateTeamMemberRaw(requestParameters, initOverrides);
  }
}
